import { MijnRoute } from '../../mijn-navigatie.model';

export const INCASSO_BATCHES_ERROR: MijnRoute = {
    path: 'fout',
    navigationEvent: 'toIncassobatchesError',
    regex: /^\/incassobatches\/fout$/,
    webcomponent: 'mijn-incassobatches-webcomponent',
    internalPath: '/fout'
};
